if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/**
 * ============================================================
 * PRODUCT SEPARATION (ONLY AFFECTS BARRIER REPAIR CREAM)
 * ============================================================
 * - Spray product remains EXACTLY the same as your original logic.
 * - Barrier product can have its own image URLs even with same variant names.
 */
function getCurrentProductHandle() {
  // Works on product pages: /products/<handle>
  const path = window.location.pathname || '';
  const parts = path.split('/').filter(Boolean);
  const idx = parts.indexOf('products');
  if (idx === -1) return '';
  return parts[idx + 1] || '';
}

// ✅ Replace these placeholder links later with your real Barrier Repair images
const BARRIER_REPAIR_IMAGES = {
  single: 'https://via.placeholder.com/160x220.png?text=Barrier+Single',
  double: 'https://via.placeholder.com/160x220.png?text=Barrier+Double+Up',
  bundle: 'https://via.placeholder.com/160x220.png?text=Barrier+Bundle',
};

// Function to setup variant images - extracted so we can call it multiple times
function setupVariantImages() {
  const variantInputs = document.querySelectorAll('.product-form__input--pill input[type="radio"]');

  // ✅ Detect product once
  const productHandle = getCurrentProductHandle();
  const isBarrierRepair = productHandle === 'barrier-repair-cream';

  variantInputs.forEach(function (input) {
    const label = input.nextElementSibling;
    if (!label) return;

    // Skip if already processed
    if (label.dataset.imagesSetup === 'true') return;

    const variantName = label.textContent.trim();

    // Add bundle-card class to label
    label.classList.add('bundle-card');

    // Force label to NOT center its children with inline styles
    label.style.cssText =
      'display: flex !important; align-items: center !important; gap: 14px !important; padding: 18px 20px !important; justify-content: flex-start !important;';

    // Clear existing label content
    label.innerHTML = '';

    // Create image container
    const imgDiv = document.createElement('div');
    imgDiv.className = 'bundle-card__media';

    const img = document.createElement('img');
    img.alt = variantName;

    /**
     * ============================================================
     * IMAGE SOURCE LOGIC
     * ============================================================
     * ✅ If Barrier Repair Cream: use Barrier-specific links.
     * ✅ Else: use your ORIGINAL Spray links exactly (unchanged).
     */
    if (isBarrierRepair) {
      if (variantName.includes('Single')) {
        img.src = BARRIER_REPAIR_IMAGES.single;
      } else if (variantName.includes('Double')) {
        img.src = BARRIER_REPAIR_IMAGES.double;
      } else if (variantName.includes('Bundle') || variantName.includes('Active Recovery')) {
        img.src = BARRIER_REPAIR_IMAGES.bundle;
      } else if (variantName.includes('Active Pack')) {
        img.src = BARRIER_REPAIR_IMAGES.bundle;
      }
    } else {
      // ✅ ORIGINAL CODE (DO NOT CHANGE)
      if (variantName.includes('Single')) {
        img.src =
          'https://cdn.shopify.com/s/files/1/0744/6511/6348/files/Untitled_design_9_1.png?v=1775951212';
      } else if (variantName.includes('Double')) {
        img.src =
          'https://cdn.shopify.com/s/files/1/0744/6511/6348/files/Untitled_design_10_1.png?v=1775951199';
      } else if (variantName.includes('Bundle') || variantName.includes('Active Recovery')) {
        img.src =
          'https://cdn.shopify.com/s/files/1/0744/6511/6348/files/ChatGPT_Image_Jan_6_2026_02_43_56_AM.png?v=1767685485';
      } else if (variantName.includes('Active Pack')) {
        img.src = 'https://via.placeholder.com/100?text=Pack';
      }
    }

    imgDiv.appendChild(img);

    // Create main content container with INLINE STYLES to force layout
    const mainDiv = document.createElement('div');
    mainDiv.className = 'bundle-card__main';
    mainDiv.style.cssText =
      'display: flex !important; flex-direction: row !important; justify-content: space-between !important; align-items: center !important; width: 100% !important; flex: 1 !important;';

    // Extract title and price from variantName
    const priceMatch = variantName.match(/\$[\d,]+\.?\d*/);
    const price = priceMatch ? priceMatch[0] : '';
    const title = variantName.replace(price, '').trim();

    // Create title container with INLINE STYLES
    const titleDiv = document.createElement('div');
    titleDiv.className = 'bundle-card__title';
    titleDiv.style.cssText =
      'text-align: left !important; font-size: 20px !important; font-weight: 700 !important; color: #fff !important; flex: 0 1 auto !important; margin: 0 !important;';
    titleDiv.textContent = title;

    // Create price container with INLINE STYLES
    const priceDiv = document.createElement('div');
    priceDiv.className = 'bundle-card__price';
    priceDiv.style.cssText =
      'text-align: right !important; font-size: 20px !important; font-weight: 800 !important; color: #fff !important; margin-left: auto !important; flex: 0 0 auto !important; white-space: nowrap !important;';
    priceDiv.textContent = price;

    // Assemble main content
    mainDiv.appendChild(titleDiv);
    mainDiv.appendChild(priceDiv);

    // Assemble the label
    label.appendChild(imgDiv);
    label.appendChild(mainDiv);

    // Mark as processed
    label.dataset.imagesSetup = 'true';
  });
}

// Run on initial load
document.addEventListener('DOMContentLoaded', function () {
  setupVariantImages();

  // Watch for variant changes and re-apply images if needed
  const variantInputs = document.querySelectorAll('.product-form__input--pill input[type="radio"]');
  variantInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      // Wait a brief moment for Shopify's default behavior to finish
      setTimeout(function () {
        setupVariantImages();
      }, 50);
    });
  });

  // Also watch for DOM changes in case Shopify re-renders the form
  const productForm = document.querySelector('product-form');
  if (productForm) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          setupVariantImages();
        }
      });
    });

    observer.observe(productForm, {
      childList: true,
      subtree: true,
      attributes: false,
    });
  }
});
